var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.hideBeginBtn)?_c('div',{staticClass:"get-started-btn-container"},[_c('hb-btn',{staticClass:"get-started-btn",on:{"click":function($event){return _vm.updateBtnStatus()}}},[_vm._v(" Begin Setup ")])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }